// Bottom toast (`.toast`), one at a time.
import { createContext, useCallback, useContext, useRef, useState, type ReactNode } from 'react';
import { cx } from '@/lib/format';

const ToastCtx = createContext<(msg: ReactNode) => void>(() => {});
export const useToast = () => useContext(ToastCtx);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [msg, setMsg] = useState<ReactNode>(null);
  const [show, setShow] = useState(false);
  const timer = useRef<number>(0);
  const toast = useCallback((m: ReactNode) => {
    setMsg(m);
    setShow(true);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setShow(false), 3200);
  }, []);
  return (
    <ToastCtx.Provider value={toast}>
      {children}
      <div className={cx('toast', show && 'show')} role="status" aria-live="polite">{msg}</div>
    </ToastCtx.Provider>
  );
}
